export default {
  removeAccents: (str) => str.toLowerCase().normalize('NFD')
      .replace(/\s+/g, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[\u0020-\u002f]/g, '')
      .replace(/[\u003a-\u003f]/g, '')
      .replace(/[\u0040]/g, '')
      .replace(/[\u0060]/g, '')
      .replace(/[\u005b-\u005f]/g, '')
      .replace(/[\u007b-\u007f]/g, '')
      .replace(/[\u0080-\u00bf]/g, '')
      .replace(/đ/g, 'd').replace(/Đ/g, 'D')
}